export var version = {
  lib: '2.10121.1',
  product: '2.10121.1',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts